'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { LogoIcon } from '@/components/shared/logo-icon';

const REDIRECT_DELAY_SECONDS = 5;
const REDIRECT_PATH = '/chats';

export function NotFoundContent() {
  const { t } = useTranslation();
  const router = useRouter();
  const [countdown, setCountdown] = useState(REDIRECT_DELAY_SECONDS);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          router.replace(REDIRECT_PATH);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [router]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 via-white to-green-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="flex flex-col items-center justify-center gap-4 text-center">
        <LogoIcon className="w-16 h-16 sm:w-20 sm:h-20" />
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
          {t('pageNotFound.title')}
        </h1>
        <p className="text-gray-600 dark:text-gray-300">
          {t('pageNotFound.redirecting', { count: countdown })}
        </p>
      </div>
    </div>
  );
}
